import { footerData } from '@/mocks/homeData';

export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg">
                <i className="ri-movie-2-line text-lg"></i>
              </span>
              <span className="font-heading text-xl">{footerData.siteName}</span>
            </div>
            <p className="text-sm text-background-50/60 leading-relaxed mb-6">
              {footerData.description}
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center bg-background-50/10 hover:bg-primary-500 rounded-md transition-colors cursor-pointer">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center bg-background-50/10 hover:bg-primary-500 rounded-md transition-colors cursor-pointer">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center bg-background-50/10 hover:bg-primary-500 rounded-md transition-colors cursor-pointer">
                <i className="ri-tiktok-line text-base"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base mb-4">快速导航</h3>
            <ul className="space-y-3">
              {footerData.quickLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavClick(link.href);
                    }}
                    className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base mb-4">合作伙伴</h3>
            <p className="text-sm text-background-50/40">
              更多合作伙伴信息即将上线，敬请期待。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-base mb-4">联系方式</h3>
            <p className="text-sm text-background-50/60 mb-2">
              <i className="ri-mail-line mr-2"></i>
              contact@91yingshi.app
            </p>
            <p className="text-sm text-background-50/60">
              <i className="ri-customer-service-2-line mr-2"></i>
              在线客服：工作日 9:00-18:00
            </p>
          </div>
        </div>

        <div className="border-t border-background-50/10 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-50/40">
            &copy; 2024 91影视看片app. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-sm text-background-50/40 hover:text-primary-400 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="text-sm text-background-50/40 hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-sm text-background-50/40 hover:text-primary-400 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}